import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useUnits } from '../../context/unitsContext';
import { toast } from 'react-toastify';
import useSubmitLock from '../../utils/useSubmitLock';

function RegisterEquipment({ onCloseModal, onSaveSuccess }) {
  const { saveEquipments, listNameEquipments } = useUnits();
  const { unitId } = useParams();

  const [equipmentTypes, setEquipmentTypes] = useState([]);
  const [selectedEquipments, setSelectedEquipments] = useState([]);
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  // Listar os equipamentos existentes
  useEffect(() => {
    const fetchEquipmentTypes = async () => {
      try {
        const response = await listNameEquipments(); // Substitua por sua função de chamada de API
        console.log('Resposta equipamentos:', response);
  
        // Acessa os dados corretamente (caso seja um objeto paginado)
        setEquipmentTypes(Array.isArray(response.results) ? response.results : []);
      } catch (error) {
        console.error('Erro ao buscar tipos de equipamentos:', error);
        setEquipmentTypes([]); // Define como array vazio em caso de erro
      }
    };
  
    fetchEquipmentTypes();
  }, [listNameEquipments]);

  // Lidar com mudanças nos checkboxes e inputs
  const handleChange = (e, id) => {
    const { name, value, type, checked } = e.target;

    setSelectedEquipments((prevState) => {
      // Se for checkbox (selecionar/desmarcar equipamento)
      if (type === 'checkbox') {
        if (checked) {
          return [
            ...prevState,
            { name: id, uso: 0, manutencao: 0, danificado: 0, unit: parseInt(unitId, 10) },
          ];
        } else {
          return prevState.filter((equip) => equip.name !== id);
        }
      }

      // Se for input de quantidade (uso, manutencao, danificado)
      return prevState.map((equip) =>
        equip.name === id ? { ...equip, [name]: parseInt(value, 10) || 0 } : equip
      );
    });
  };

  // Enviar os dados para o backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      if (selectedEquipments.length === 0) {
        toast.warning('Selecione pelo menos um equipamento.');
        return;
      }

      try {
        const response = await saveEquipments(selectedEquipments);
        console.log('Resposta da API:', response);
        onSaveSuccess();
        onCloseModal();
      } catch (error) {
        console.error('Erro ao cadastrar equipamentos:', error);
        toast.error('Erro ao cadastrar equipamentos.');
      }
    });
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="checkbox-container">
          {equipmentTypes.map((type) => (
            <div key={type.id} className="content-items">
              <div>
                <input
                  type="checkbox"
                  id={`type${type.id}`}
                  onChange={(e) => handleChange(e, type.id)}
                />
                <label htmlFor={`type${type.id}`}>{type.name}</label>
              </div>
              <div>
                <input
                  min="0"
                  type="number"
                  placeholder="Uso"
                  name="uso"
                  onChange={(e) => handleChange(e, type.id)}
                />
                <input
                  min="0"
                  type="number"
                  placeholder="Manutenção"
                  name="manutencao"
                  onChange={(e) => handleChange(e, type.id)}
                />
                <input
                  min="0"
                  type="number"
                  placeholder="Danificado"
                  name="danificado"
                  onChange={(e) => handleChange(e, type.id)}
                />
              </div>
            </div>
          ))}
        </div>
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Salvando...' : 'Salvar'}
        </button>
      </form>
    </div>
  );
}

export default RegisterEquipment;
